import { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const TBody: FC<Props> = ({ children }) => {
  return <tbody>{children}</tbody>;
};
